export default __webpack_public_path__ + "static/media/solutionBanniere.388ada1b.jpg";